import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    offer_statuses: [],
    offer_statusesCount: 0,
    offer_status: {},
    offer_statusSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getOffer_statuses(state) {
      return state.offer_statuses
    },
    getOffer_statusesCount(state) {
      return state.offer_statusesCount
    },
    getOffer_status(state) {
      return state.offer_status
    },
    getOffer_statusSaveStatus(state) {
      return state.offer_statusSave
    },
  },
  mutations: {
    OFFER_STATUSES_LIST(state, data) {
      state.offer_statuses = data
    },
    OFFER_STATUS_VIEW(state, data) {
      state.offer_status = data
    },
    OFFER_STATUSES_COUNT(state, data) {
      state.offer_statusesCount = data
    },
    OFFER_STATUS_SAVE(state, data) {
      state.offer_statusSave = data
    },
  },
  actions: {
    offer_statusesList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/defines/offer_status/getData', data)
        .then(response => {
          commit('OFFER_STATUSES_LIST', response.data.data)
          commit('OFFER_STATUSES_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    offer_statusView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'offer_statuses.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/defines/offer_status/getData', data)
        .then(response => {
          commit('OFFER_STATUS_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    offer_statusSave({ commit }, postData) {
      const data = JSON.stringify({ formData: postData })
      axiosIns
        .post('/defines/offer_status/saveData', data)
        .then(response => {
          commit('OFFER_STATUS_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
